const LABEL_LOADING = "LABEL_LOADING";
const LABEL_SUCCESS = "LABEL_SUCCESS";
const LABEL_ERROR = "LABEL_ERROR";

export { LABEL_LOADING, LABEL_ERROR, LABEL_SUCCESS };
